import { API_ENDPOINTS } from "../constants/apiEndpoints";
import axiosInstance from "../config/axiosInstance";

/**
 * Lấy dữ liệu Chính sách nhân sự theo mã ngôn ngữ
 * @param {string} languageCode - Mã ngôn ngữ (vd: 'vi', 'en', 'jp')
 * @returns {Promise<Object|null>} - Bản ghi đầu tiên hoặc null
 */
export const getIntroducePoliciesByLanguage = async (languageCode) => {
    const response = await axiosInstance.get(
        API_ENDPOINTS.INTRODUCE_POLICIES.GET_BY_LANGUAGE(languageCode)
    );
    const data = response.data;

    if (data && data.success && Array.isArray(data.data) && data.data.length > 0) {
        return data.data[0];
    }

    return null;
};
